/**
 * Security utilities for the frontend.
 * Contains functions for client-side password hashing.
 */

/**
 * Hash password using SHA-256 before sending to backend.
 * This adds a layer of security so plaintext password is never visible in DevTools.
 * 
 * @param {string} password - The plain text password to hash.
 * @returns {Promise<string>} - The SHA-256 hashed password as a hex string.
 */
export async function hashPassword(password) {
    const encoder = new TextEncoder();
    const data = encoder.encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}
